// extracted by mini-css-extract-plugin
module.exports = {"countInput":"AmountSelection_countInput__3Bs4j"};